/** Mirrors backend `Sestek.AgenticCX.Enums.TimeDisplayFormat`. */
export enum TimeDisplayFormat {
  TwentyFourHour = 1,
  TwelveHour = 2,
}
